var map = {
	"./azure.png": 108,
	"./bootstrap.png": 357,
	"./c-sharp.png": 438,
	"./css-certificate.png": 985,
	"./css.png": 605,
	"./docker.png": 787,
	"./express.png": 523,
	"./fastest-presser.png": 181,
	"./git-user-searcher.png": 277,
	"./git.png": 607,
	"./github.png": 591,
	"./google.png": 904,
	"./heroku.png": 807,
	"./html-certificate.png": 233,
	"./html.png": 265,
	"./js-certificate.png": 717,
	"./js.png": 166,
	"./knexjs.png": 2,
	"./meal-sharing.png": 876,
	"./mysql.png": 847,
	"./nodejs.png": 719,
	"./profile.png": 132,
	"./react.png": 47,
	"./responsive-certificate.png": 914,
	"./responsive.png": 913,
	"./storybook.png": 52,
	"./swagger.png": 197,
	"./typescript.png": 766,
	"./weather-app.png": 823,
	"./webshop.png": 260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;